import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;

import { css, memoizeStyle } from "../../../../lib/theming/Emotion";
var styles = {
  file: function file() {
    return css(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n      width: 100%;\n    "])));
  },
  fileWrapper: function fileWrapper(t) {
    return css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["\n      width: 100%;\n      height: 32px;\n      display: flex;\n      align-items: center;\n      box-sizing: border-box;\n      padding: ", " ", ";\n    "])), t.fileUploaderPaddingY, t.fileUploaderPaddingX);
  },
  fileWrapperSmall: function fileWrapperSmall(t) {
    return css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteralLoose(["\n      padding: ", " ", ";\n    "])), t.fileUploaderPaddingYSmall, t.fileUploaderPaddingXSmall);
  },
  fileWrapperMedium: function fileWrapperMedium(t) {
    return css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteralLoose(["\n      padding: ", " ", ";\n    "])), t.fileUploaderPaddingYMedium, t.fileUploaderPaddingXMedium);
  },
  fileWrapperLarge: function fileWrapperLarge(t) {
    return css(_templateObject5 || (_templateObject5 = _taggedTemplateLiteralLoose(["\n      padding: ", " ", ";\n    "])), t.fileUploaderPaddingYLarge, t.fileUploaderPaddingXLarge);
  }
};
export var jsStyles = memoizeStyle(styles);